import React, { useState } from 'react';

interface PaymentInfoProps {
    onSubmitPayment: (info: {
        cardName: string;
        cardNumber: string;
        expiry: string;
        cvv: string;
        billingAddress: string;
    }) => void;
}

const PaymentInfo: React.FC<PaymentInfoProps> = ({ onSubmitPayment }) => {
    const [cardName, setCardName] = useState('');
    const [cardNumber, setCardNumber] = useState('');
    const [expiry, setExpiry] = useState('');
    const [cvv, setCvv] = useState('');
    const [billingAddress, setBillingAddress] = useState('');

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        onSubmitPayment({ cardName, cardNumber, expiry, cvv, billingAddress });
    };

    return (
        <div className="flex items-center justify-center h-full">
            <div className="w-full max-w-md p-4 bg-stone rounded-lg shadow-md">
                <h2 className="text-2xl font-bold text-center text-terracotta font-cinzel mb-4">Payment Information</h2>
                <form onSubmit={handleSubmit} className="space-y-3">
                    <div>
                        <label htmlFor="cardName" className="block text-sm font-bold text-stone-dark font-cinzel">Name on Card</label>
                        <input
                            type="text"
                            id="cardName"
                            value={cardName}
                            onChange={(e) => setCardName(e.target.value)}
                            className="w-full px-2 py-1 mt-1 text-sm text-stone-dark border border-stone-dark rounded-md focus:outline-none focus:ring-1 focus:ring-terracotta bg-warm-cream"
                            required
                        />
                    </div>
                    <div>
                        <label htmlFor="cardNumber" className="block text-sm font-bold text-stone-dark font-cinzel">Card Number</label>
                        <input
                            type="text"
                            id="cardNumber"
                            value={cardNumber}
                            onChange={(e) => setCardNumber(e.target.value)}
                            className="w-full px-2 py-1 mt-1 text-sm text-stone-dark border border-stone-dark rounded-md focus:outline-none focus:ring-1 focus:ring-terracotta bg-warm-cream"
                            required
                        />
                    </div>
                    <div className="grid grid-cols-2 gap-3">
                        <div>
                            <label htmlFor="expiry" className="block text-sm font-bold text-stone-dark font-cinzel">Expiry Date</label>
                            <input
                                type="text"
                                id="expiry"
                                value={expiry}
                                onChange={(e) => setExpiry(e.target.value)}
                                placeholder="MM/YY"
                                className="w-full px-2 py-1 mt-1 text-sm text-stone-dark border border-stone-dark rounded-md focus:outline-none focus:ring-1 focus:ring-terracotta bg-warm-cream"
                                required
                            />
                        </div>
                        <div>
                            <label htmlFor="cvv" className="block text-sm font-bold text-stone-dark font-cinzel">CVV</label>
                            <input
                                type="text"
                                id="cvv"
                                value={cvv}
                                onChange={(e) => setCvv(e.target.value)}
                                className="w-full px-2 py-1 mt-1 text-sm text-stone-dark border border-stone-dark rounded-md focus:outline-none focus:ring-1 focus:ring-terracotta bg-warm-cream"
                                required
                            />
                        </div>
                    </div>
                    <div>
                        <label htmlFor="billingAddress" className="block text-sm font-bold text-stone-dark font-cinzel">Billing Address</label>
                        <textarea
                            id="billingAddress"
                            value={billingAddress}
                            onChange={(e) => setBillingAddress(e.target.value)}
                            className="w-full px-2 py-1 mt-1 text-sm text-stone-dark border border-stone-dark rounded-md focus:outline-none focus:ring-1 focus:ring-terracotta bg-warm-cream h-16 resize-none"
                            required
                        ></textarea>
                    </div>
                    <button
                        type="submit"
                        className="w-full px-3 py-1.5 text-warm-cream bg-terracotta rounded-md hover:bg-golden-yellow hover:text-stone-dark transition duration-300 ease-in-out focus:outline-none focus:ring-1 focus:ring-golden-yellow focus:ring-offset-2 font-cinzel font-bold text-md"
                    >
                        Complete Subscription
                    </button>
                </form>
            </div>
        </div>
    );
};

export default PaymentInfo;